var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { FeaturedService } from "../../services/featured.service";
import { EduComponent } from "../../utils/eduComponent";
import { CHNode } from "../../models/node.model";
var FeaturedComponent = /** @class */ (function (_super) {
    __extends(FeaturedComponent, _super);
    function FeaturedComponent(featuredService) {
        var _this = _super.call(this) || this;
        _this.featuredService = featuredService;
        _this.featuredResources = [];
        _this.placeholderImg = null;
        _this.gtmPrefix = "homepage-featured";
        _this.placeholderImg = require("../../../assets/placeholder-image.svg");
        return _this;
    }
    FeaturedComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.featuredService
            .getFeaturedResources()
            .subscribe(function (featuredResources) {
            var _a;
            (_a = _this.featuredResources).push.apply(_a, featuredResources);
        }));
    };
    FeaturedComponent.prototype.getBrowseURL = function (resource) {
        if (!resource.subject || !resource.subject.slug) {
            return null;
        }
        return CHNode.getBrowseURLForSlug(resource.subject.slug);
    };
    return FeaturedComponent;
}(EduComponent));
export { FeaturedComponent };
